export const EDR_TITLE = "edr_identification.yaml";
export const EDR_DOCUMENT_TYPE = "registerExtract";
